import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import Reveal from "@/components/Reveal";
import { api } from "@/lib/api";
import { useLang } from "@/i18n";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const { t } = useLang();

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-white text-slate-600 px-6 md:px-12 lg:px-24 py-20 lg:py-32"
    >
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase text-[#ED1C24] mb-4 text-center">
          {t("testi_label")}
        </p>
        <h2 className="font-display font-semibold text-slate-900 text-4xl sm:text-5xl tracking-tight text-center mb-4">
          {t("testi_title").replace(".", "")}<span className="text-[#ED1C24]">.</span>
        </h2>
        <div className="w-16 h-1 bg-gradient-to-r from-[#ED1C24] to-[#FFC61A] mx-auto mb-16" />
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {items.map((item, i) => (
          <Reveal key={item.id} delay={(i % 2) * 0.1}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="group h-full bg-white border border-slate-200 p-8 hover:border-[#ED1C24]/50 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(11,17,32,0.08)] transition-[border-color,transform,box-shadow] duration-500"
            >
              <Quote size={26} className="text-[#FFC61A] mb-5" />
              <h3 className="font-display font-semibold text-slate-900 text-xl mb-4">{item.org}</h3>
              <blockquote className="text-sm lg:text-base leading-relaxed text-slate-600 mb-8">
                {item.quote}
              </blockquote>
              <figcaption className="border-t border-slate-100 pt-5">
                <p className="text-[#ED1C24] font-medium text-sm">{item.author}</p>
                <p className="text-slate-500 text-xs mt-0.5">{item.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
